// extracted by mini-css-extract-plugin
export default {"menuBg":"#304156","menuText":"#bfcbd9","menuActiveText":"#409eff"};